import React from "react"

import { Fragment, useState } from "react"
import { Popover, Transition, Dialog, Tab, Disclosure } from "@headlessui/react"
import { formatPrice } from "../utils/format-price"
import {
  MenuIcon,
  QuestionMarkCircleIcon,
  ShoppingBagIcon,
  XIcon,
  PlusSmIcon,
  MinusSmIcon,
} from "@heroicons/react/outline"
import Hamburger from "../assets/icons/hamburger"
import { Link } from "gatsby"

import { CartButton } from "../components/cart-button"
import SearchIcon from "../icons/search"
import { Toast } from "../components/toast"

import logo from "../assets/Sun.png"

import abundance from "../assets/intentions/Abundance.png"
import calming from "../assets/intentions/Calming.png"
import healing from "../assets/intentions/Healing.png"
import love from "../assets/intentions/Love.png"
import beginnings from "../assets/intentions/Beginnings.png"
import protection from "../assets/intentions/Protection.png"

import { StoreContext } from "../context/store-context"
import CartItem from "./CartItem"

import crystalIcon from "../assets/categories/CrystalIcon.png"
import jewelleryIcon from "../assets/categories/JewelleryIcon.png"
import bookIcon from "../assets/categories/BookIcon.png"
import tarotIcon from "../assets/categories/TarotIcon.png"

const currencies = ["CAD", "USD", "AUD", "EUR", "GBP"]

const navigation = {
  crystals: [
    {
      name: "Crystals",
      crystals: [
        {
          name: "Calming & Grounding",
          href: "/catalogue?t=anxiety&t=focus",
          icon: calming,
        },
        {
          name: "Love & Happiness",
          href: "/catalogue?t=love&t=happiness",
          icon: love,
        },
        { name: "Healing", href: "/catalogue?t=healing", icon: healing },
        {
          name: "New Beginnings",
          href: "/catalogue?t=new%20beginnings",
          icon: beginnings,
        },
        {
          name: "Protection",
          href: "/catalogue?t=protection",
          icon: protection,
        },
        { name: "Abundance", href: "/catalogue?t=abundance", icon: abundance },
      ],
      form: [
        { name: "Specimens", href: "/catalogue?t=specimen" },
        { name: "Tumbles", href: "/catalogue?t=tumble" },
        { name: "Pendulums", href: "/catalogue?t=pendulum" },
        { name: "Points & Generators", href: "/catalogue?t=generator" },
        { name: "Free Formed & Carved", href: "/catalogue?t=carved" },
        { name: "Spheres", href: "/catalogue?t=sphere" },
        { name: "Wands", href: "/catalogue?t=wand" },
        { name: "Clusters", href: "/catalogue?t=cluster" },
        { name: "Pyramids", href: "/catalogue?t=pyramid" },
        { name: "Raw & Rough", href: "/catalogue?t=raw" },
        { name: "Chips", href: "/catalogue?t=chips" },
      ],
      feeling: [
        { name: "Anxiety", href: "/catalogue?t=anxiety" },
        { name: "Clarity", href: "/catalogue?t=clarity" },
        { name: "Confidence", href: "/catalogue?t=confidence" },
        { name: "Fertility", href: "/catalogue?t=fertility" },
        { name: "Focus", href: "/catalogue?t=focus" },
        { name: "Grief", href: "/catalogue?t=grief" },
        { name: "Happiness", href: "/catalogue?t=happiness" },
        { name: "Love", href: "/catalogue?t=love" },
        { name: "Stress", href: "/catalogue?t=stress" },
        { name: "Sleep", href: "/catalogue?t=sleep" },
        { name: "Trust", href: "/catalogue?t=trust" },
      ],
      collections: [
        { name: "All Crystals", href: "/catalogue?p=Crystals" },
        { name: "Best Sellers", href: "/catalogue?s=BEST_SELLING" },
        { name: "New Arrivals", href: "/catalogue?s=CREATED_AT" },
        { name: "Kits", href: "/catalogue?t=kit" },
        { name: "Statement Pieces", href: "/catalogue?t=statement" },
      ],
    },
  ],

  other: [
    {
      name: "Jewellery",
      types: [
        { name: "Shop all", href: "/catalogue?p=Jewellery" },
        { name: "Earrings", href: "/catalogue?t=earrings" },
        { name: "Rings", href: "/catalogue?t=ring" },
        { name: "Pendants", href: "/catalogue?t=pendant" },
        { name: "Anklets", href: "/catalogue?t=anklet" },
      ],
    },
    {
      name: "Aromatherapy",
      types: [
        { name: "Shop all", href: "/catalogue?p=Aromatherapy" },
        { name: "Essential Oils", href: "/catalogue?t=essentialoil" },
        { name: "Sprays", href: "/catalogue?t=spray" },
        { name: "Candles", href: "/catalogue?t=candles" },
        { name: "Incense", href: "/catalogue?t=incense" },
        { name: "Sage", href: "/catalogue?t=sage" },
      ],
    },
  ],
  simple: [
    { name: "Books", href: "/catalogue?p=Books" },
    { name: "Cards", href: "/catalogue?p=Tarot%20%26%20Oracle%20Cards" },
    { name: "Giftware", href: "/catalogue?p=Giftware" },
  ],
}

const navigation2 = {
  categories: [
    {
      name: "New Arrivals",
      featured: [
        {
          name: "2024 LUNAR AND SEASONAL DIARY - SOUTHERN HEMISPHERE",
          href: "/products/books/2024-lunar-and-seasonal-diary-southern-hemisphere/",
          imageSrc:
            "https://cdn.shopify.com/s/files/1/0645/9667/2753/files/Lunar-and-Seasonal-2024-Diary_1_640x640_crop_center.jpg.webp?v=1691114821",
          imageAlt: "2024 LUNAR AND SEASONAL DIARY - SOUTHERN HEMISPHERE",
        },
        {
          name: "Moonology™ Diary 2024",
          href: "/products/books/moonology-diary-2024/",
          imageSrc:
            "https://cdn.shopify.com/s/files/1/0645/9667/2753/files/Moonology-2024-Diary_1_640x640_crop_center.jpg.webp?v=1691115129",
          imageAlt: "Moonology™ Diary 2024",
        },
        {
          name: "Amazonite Silver Earrings",
          href: "/products/jewellery/amazonite-e47/",
          imageSrc:
            "https://cdn.shopify.com/s/files/1/0645/9667/2753/products/amazonite-e47_640x640_crop_center.jpg.webp?v=1661136675",
          imageAlt: "Amazonite Silver Earrings",
        },
        {
          name: "Selenite Carved Moon",
          href: "/products/crystals/selenite-carved-moon/",
          imageSrc:
            "https://cdn.shopify.com/s/files/1/0645/9667/2753/products/selenite-carved-moon_640x640_crop_center.jpg.webp?v=1661136331",
          imageAlt: "Selenite Carved Moon",
        },
      ],
    },
    {
      name: "Collections",
      featured: [
        {
          name: "Kits",
          href: "/catalogue?t=kit",
          imageSrc:
            "https://cdn.shopify.com/s/files/1/0645/9667/2753/products/travelkit_640x640_crop_center.jpg.webp?v=1661908951",
          imageAlt: "Shop Kits",
        },
        {
          name: "Essentials",
          href: "/catalogue?t=essential",
          imageSrc:
            "https://cdn.shopify.com/s/files/1/0645/9667/2753/products/D1D695C8-D77F-4ABA-B996-A2E9FC50FD99-min_640x640_crop_center.jpg.webp?v=1661927243",
          imageAlt: "Shop Essentials",
        },
        {
          name: "Statement Pieces",
          href: "/catalogue?t=statement",
          imageSrc:
            "https://cdn.shopify.com/s/files/1/0645/9667/2753/products/rainbowmoonstone-sphere-b_640x640_crop_center.jpg.webp?v=1661136302",
          imageAlt: "Shop Statement Pieces",
        },
        {
          name: "Zodiac",
          href: "/catalogue?t=zodiac",
          imageSrc:
            "https://cdn.shopify.com/s/files/1/0645/9667/2753/products/gemini-zodiac-crystal-mug_533x533_crop_center.jpg.webp?v=1661136925",
          imageAlt: "Shop Zodiac",
        },
      ],
    },
  ],
  pages: [
    { name: "Company", href: "#" },
    { name: "Stores", href: "#" },
  ],
}

function classNames(...classes) {
  return classes.filter(Boolean).join(" ")
}

const Navbar = () => {
  const { checkout, loading, didJustAddToCart } = React.useContext(StoreContext)

  const items = checkout ? checkout.lineItems : []

  const emptyCart = checkout.lineItems.length === 0

  const handleCheckout = () => {
    window.open(checkout.webUrl)
    window.gtag("event", "checkout", {
      event_category: "checkout",
      event_label: "checkout",
    })
  }

  const quantity = items.reduce((total, item) => {
    return total + item.quantity
  }, 0)

  const [open, setOpen] = useState(false)
  const [openCart, setOpenCart] = useState(false)

  return (
    <div className="fixed w-full [z-index:100] border-b-4 border-ec-earth">
      <div className="relative bg-ec-sky">
        <div className="max-w-screen-2xl mx-auto py-2 px-3 sm:px-6 lg:px-8">
          <div className=" sm:text-center sm:px-16">
            <p className="font-heading text-xl text-white">
              <span className="md:hidden text-md mx-auto text-center block">
                <strong>FREE SHIPPING</strong> on orders over $100
              </span>
              <span className="hidden md:inline">
                <strong>FREE SHIPPING</strong> on orders over $100
              </span>
              <span className="hidden lg:inline-block sm:ml-2 sm:inline-block">
                <a
                  href="/catalogue?p=Crystals"
                  className="text-white font-bold underline"
                >
                  {" "}
                  Shop Crystals <span aria-hidden="true">&rarr;</span>
                </a>
              </span>
            </p>
          </div>
          <div className="absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start">
            {/* <button
              type="button"
              className="flex p-2 rounded-md hover:bg-ec-earth focus:outline-none focus:ring-2 focus:ring-white"
            >
              <span className="sr-only">Dismiss</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </button> */}
          </div>
        </div>
      </div>

      <div className="bg-white">
        <header className="relative bg-white">
          <nav
            aria-label="Top"
            className="max-w-screen-2xl mx-auto sm:px-6 lg:px-8"
          >
            <div className=" px-4 sm:px-0 sm:pb-0">
              <div className="h-20 lg:h-24 grid grid-cols-4 sm:flex items-center justify-between">
                {/* MOBILE MENU BUTTON */}
                <button
                  type="button"
                  className="-ml-2 bg-white p-2 rounded-md text-gray-400 md:hidden"
                  onClick={() => setOpen(true)}
                >
                  <span className="sr-only">Open menu</span>
                  <Hamburger className="bg-blue" aria-hidden="true" />
                </button>

                {/* MOBILE MENU */}
                <Transition.Root show={open} as={Fragment}>
                  <Dialog
                    as="div"
                    className="relative [z-index:101] lg:hidden"
                    onClose={setOpen}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="transition-opacity ease-linear duration-500"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="transition-opacity ease-linear duration-500"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 flex z-40">
                      <Transition.Child
                        as={Fragment}
                        enter="transition ease-in-out duration-500 transform"
                        enterFrom="-translate-x-full"
                        enterTo="translate-x-0"
                        leave="transition ease-in-out duration-500 transform"
                        leaveFrom="translate-x-0"
                        leaveTo="-translate-x-full"
                      >
                        <Dialog.Panel className="relative max-w-sm w-full bg-ec-air font-body shadow-xl flex flex-col overflow-y-auto customnav">
                          <div className="px-4 pt-5 pb-2 flex">
                            <button
                              type="button"
                              className="-m-2 p-2 rounded-md inline-flex items-center justify-center text-gray-400"
                              onClick={() => setOpen(false)}
                            >
                              <span className="sr-only">Close menu</span>
                              <XIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>

                          {/* Links */}
                          <Tab.Group as="div" className="mt-2">
                            <div className="border-b border-ec-blue">
                              <Tab.List className="-mb-px flex px-4 space-x-8">
                                {navigation2.categories.map((category) => (
                                  <Tab
                                    key={category.name}
                                    className={({ selected }) =>
                                      classNames(
                                        selected
                                          ? "text-ec-earth border-ec-earth"
                                          : "text-gray-900 border-transparent",
                                        "flex-1 whitespace-nowrap py-4 px-1 border-b-2 text-lg font-heading"
                                      )
                                    }
                                  >
                                    {category.name}
                                  </Tab>
                                ))}
                              </Tab.List>
                            </div>
                            <Tab.Panels as={Fragment}>
                              {navigation2.categories.map((category) => (
                                <Tab.Panel
                                  key={category.name}
                                  className="px-4 py-6 space-y-12"
                                >
                                  <div className="grid grid-cols-2 gap-x-4 gap-y-10">
                                    {category.featured.map((item) => (
                                      <div
                                        key={item.name}
                                        className="group relative text-center"
                                      >
                                        <div className="aspect-w-1 aspect-h-1 max-h-[175px] rounded-md bg-gray-100 overflow-hidden group-hover:opacity-75">
                                          <img
                                            src={item.imageSrc}
                                            alt={item.imageAlt}
                                            className="object-center object-cover"
                                          />
                                        </div>
                                        <a
                                          href={item.href}
                                          className="mt-6 block text-sm font-medium text-gray-900"
                                          onClick={() => setOpen(false)}
                                        >
                                          <span
                                            className="absolute z-10 inset-0"
                                            aria-hidden="true"
                                          />
                                          <p className="font-body text-ec-sea text-md">
                                            {item.name}
                                          </p>
                                        </a>
                                        <p
                                          aria-hidden="true"
                                          className="mt-1 text-sm text-gray-500"
                                        >
                                          Shop Now
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                </Tab.Panel>
                              ))}
                            </Tab.Panels>
                            <div className="flex justify-center items-center">
                              <Link
                                to="/catalogue"
                                className="flex items-center justify-center  w-36 px-4 py-2 border-2 border-ec-sea rounded-full text-white bg-ec-sea hover:bg-transparent hover:text-ec-sea transition ease-in-out text-lg font-heading  sm:px-8 mb-6"
                              >
                                Shop all
                              </Link>
                            </div>
                          </Tab.Group>
                          <div className="border-t divide-y ">
                            {navigation.crystals.map((detail) => (
                              <Disclosure
                                as="div"
                                key={detail.name}
                                className="px-4"
                              >
                                {({ open }) => (
                                  <>
                                    <h3>
                                      <Disclosure.Button className="group relative w-full py-6 flex justify-between items-center text-left">
                                        <span
                                          className={classNames(
                                            open
                                              ? "text-ec-sea"
                                              : "text-gray-900",
                                            "text-lg font-medium font-heading"
                                          )}
                                        >
                                          {detail.name}
                                        </span>
                                        <span className="ml-6 flex items-center">
                                          {open ? (
                                            <MinusSmIcon
                                              className="block h-6 w-6 text-ec-blue group-hover:text-ec-blue"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <PlusSmIcon
                                              className="block h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                              aria-hidden="true"
                                            />
                                          )}
                                        </span>
                                      </Disclosure.Button>
                                    </h3>
                                    <Disclosure.Panel
                                      as="div"
                                      className="pb-6 prose prose-sm"
                                    >
                                      <ul role="list">
                                        <li className="pl-6 pb-4 text-md text-ec-sea hover:text-ec-earth transition">
                                          <a
                                            href="/catalogue/?p=Crystals"
                                            onClick={() => setOpen(false)}
                                          >
                                            Shop all
                                          </a>
                                        </li>
                                        {detail.crystals.map((item) => (
                                          <li
                                            className="pl-6 pb-4 text-md text-ec-sea hover:text-ec-earth transition"
                                            key={item}
                                          >
                                            <a
                                              href={item.href}
                                              onClick={() => setOpen(false)}
                                            >
                                              {item.name}
                                            </a>
                                          </li>
                                        ))}
                                      </ul>
                                    </Disclosure.Panel>
                                  </>
                                )}
                              </Disclosure>
                            ))}
                            {navigation.other.map((detail) => (
                              <Disclosure
                                as="div"
                                key={detail.name}
                                className="px-4"
                              >
                                {({ open }) => (
                                  <>
                                    <h3>
                                      <Disclosure.Button className="group relative w-full py-6 flex justify-between items-center text-left">
                                        <span
                                          className={classNames(
                                            open
                                              ? "text-ec-sea"
                                              : "text-gray-900",
                                            "text-lg font-medium font-heading"
                                          )}
                                        >
                                          {detail.name}
                                        </span>
                                        <span className="ml-6 flex items-center">
                                          {open ? (
                                            <MinusSmIcon
                                              className="block h-6 w-6 text-ec-blue group-hover:text-ec-blue"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <PlusSmIcon
                                              className="block h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                              aria-hidden="true"
                                            />
                                          )}
                                        </span>
                                      </Disclosure.Button>
                                    </h3>
                                    <Disclosure.Panel
                                      as="div"
                                      className="pb-6 prose prose-sm"
                                    >
                                      <ul role="list">
                                        {detail.types.map((item) => (
                                          <li
                                            className="pl-6 pb-4 text-md text-ec-sea hover:text-ec-earth transition"
                                            key={item}
                                          >
                                            <a
                                              href={item.href}
                                              onClick={() => setOpen(false)}
                                            >
                                              {item.name}
                                            </a>
                                          </li>
                                        ))}
                                      </ul>
                                    </Disclosure.Panel>
                                  </>
                                )}
                              </Disclosure>
                            ))}
                          </div>
                          <div className="border-t divide-y divide-ec-blue">
                            {navigation.simple.map((detail) => (
                              <div
                                className="text-lg font-heading py-6 px-4"
                                key={detail.name}
                              >
                                <a href={detail.href}>{detail.name}</a>
                              </div>
                            ))}
                          </div>

                          <div className="border-t border-ec-blue grid grid-cols-2 grid-gap-2">
                            <Link
                              to="/articles"
                              className="bg-ec-sea font-heading text-white text-xl px-4 py-4 w-full text-center border-r border-ec-air"
                            >
                              Discover
                            </Link>
                            <Link
                              to="/contact"
                              className="bg-ec-sea font-heading text-white text-xl px-4 py-4 w-full text-center border-l border-ec-air"
                            >
                              Contact
                            </Link>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </Dialog>
                </Transition.Root>

                {/* Logo */}
                <div className="flex-1 flex col-span-2 mx-auto">
                  <Link to="/" className="">
                    <img
                      className="h-20 w-auto lg:h-28 -mb-[19px] lg:-mb-[11px] w-full"
                      src={logo}
                      alt="elemental connection logo"
                    />
                  </Link>
                </div>

                {/* Flyout menus */}
                <Popover.Group className="hidden sm:flex absolute bottom-0 inset-x-0 sm:static sm:flex-1 sm:self-stretch justify-center">
                  <div className="border-t h-14 px-4 flex space-x-8 overflow-x-auto pb-px sm:h-full sm:border-t-0 sm:justify-center sm:overflow-visible sm:pb-0">
                    {navigation.crystals.map((category, categoryIdx) => (
                      <Popover key={categoryIdx} className="flex">
                        {({ open }) => (
                          <>
                            <div className="relative flex">
                              <Popover.Button
                                className={classNames(
                                  open
                                    ? "border-ec-earth text-ec-earth "
                                    : "border-transparent text-gray-700 hover:text-gray-800",
                                  "relative z-10 flex items-center transition-colors ease-out duration-200 text-xl font-heading uppercase text-ec-sea font-medium -mb-px pt-px outline-none"
                                )}
                              >
                                {category.name}
                                <svg
                                  width="36"
                                  height="32"
                                  viewBox="0 0 36 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className={
                                    open
                                      ? "h-[12px] w-[12px] -ml-6px opacity-100 transition ease-in-out absolute bottom-4 left-1/2"
                                      : "h-[12px] w-[12px] -ml-6px opacity-0 transition ease-in-out absolute bottom-4 left-1/2"
                                  }
                                >
                                  <path
                                    d="M17.8431 0.213959L35.6862 31.4842H0L17.8431 0.213959Z"
                                    fill="#0D3552"
                                  />
                                </svg>
                              </Popover.Button>
                            </div>

                            <Transition
                              as={Fragment}
                              enter="transition ease-out duration-200"
                              enterFrom="opacity-0"
                              enterTo="opacity-100"
                              leave="transition ease-in duration-150"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <Popover.Panel className="absolute top-full inset-x-0 text-gray-500 sm:text-xl font-heading text-ec-sea border-t-4 border-b-2 border-ec-earth">
                                {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}
                                <div
                                  className="absolute inset-0 top-1/2 bg-ec-air shadow"
                                  aria-hidden="true"
                                />

                                <div className="relative bg-ec-air">
                                  <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
                                    <div className="grid grid-cols-1 items-start gap-y-10 gap-x-6 pt-10 pb-12 md:grid-cols-5 lg:gap-x-16">
                                      <div className="grid grid-cols-1 col-span-2 gap-y-10 gap-x-6 lg:gap-x-8">
                                        <div>
                                          <p
                                            id="crystals-heading"
                                            className="text-ec-earth text-2xl"
                                          >
                                            Crystals By Intention
                                          </p>
                                          <div className="mt-4 border-t border-ec-blue pt-6 sm:grid sm:grid-cols-3 sm:gap-x-2 sm:gap-y-8">
                                            {category.crystals.map((item) => (
                                              <div
                                                key={item.name}
                                                className="flex"
                                              >
                                                <a
                                                  href={item.href}
                                                  className="hover:text-gray-800"
                                                >
                                                  <img src={item.icon} alt="" />
                                                  <p className="text-center">
                                                    {item.name}
                                                  </p>
                                                </a>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="grid col-span-3 grid-cols-1">
                                        <h2 className="text-2xl font-heading text-ec-earth pb-4 border-b border-ec-blue">
                                          Shop By
                                        </h2>
                                        <div className="pt-12 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-3 lg:gap-x-8">
                                          <div>
                                            <p
                                              id="accessories-heading"
                                              className="font-medium text-gray-900"
                                            >
                                              Form
                                            </p>
                                            <ul
                                              role="list"
                                              aria-labelledby="accessories-heading"
                                              className="mt-4 border-t border-ec-blue pt-6 space-y-6 sm:space-y-4"
                                            >
                                              {category.form.map((item) => (
                                                <li
                                                  key={item.name}
                                                  className="flex"
                                                >
                                                  <a
                                                    href={item.href}
                                                    className="hover:text-gray-800"
                                                  >
                                                    {item.name}
                                                  </a>
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                          <div>
                                            <p
                                              id="categories-heading"
                                              className="font-medium text-gray-900"
                                            >
                                              Feeling
                                            </p>
                                            <ul
                                              role="list"
                                              aria-labelledby="categories-heading"
                                              className="mt-4 border-t border-ec-blue pt-6 space-y-6 sm:space-y-4"
                                            >
                                              {category.feeling.map((item) => (
                                                <li
                                                  key={item.name}
                                                  className="flex"
                                                >
                                                  <a
                                                    href={item.href}
                                                    className="hover:text-gray-800"
                                                  >
                                                    {item.name}
                                                  </a>
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                          <div>
                                            <p
                                              id="categories-heading"
                                              className="font-medium text-gray-900"
                                            >
                                              Collections
                                            </p>
                                            <ul
                                              role="list"
                                              aria-labelledby="categories-heading"
                                              className="mt-4 border-t border-ec-blue pt-6 space-y-6 sm:space-y-4"
                                            >
                                              {category.collections.map(
                                                (item) => (
                                                  <li
                                                    key={item.name}
                                                    className="flex"
                                                  >
                                                    <a
                                                      href={item.href}
                                                      className="hover:text-gray-800"
                                                    >
                                                      {item.name}
                                                    </a>
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Popover.Panel>
                            </Transition>
                          </>
                        )}
                      </Popover>
                    ))}

                    {navigation.other.map((category, categoryIdx) => (
                      <Popover key={categoryIdx} className="flex">
                        {({ open }) => (
                          <>
                            <div className="relative flex">
                              <Popover.Button
                                className={classNames(
                                  open
                                    ? "border-ec-earth text-ec-earth"
                                    : "border-transparent text-gray-700 hover:text-gray-800",
                                  "relative z-10 flex items-center transition-colors ease-out duration-200 text-xl font-heading uppercase text-ec-sea font-medium -mb-px pt-px outline-none"
                                )}
                              >
                                {category.name}
                                <svg
                                  width="36"
                                  height="32"
                                  viewBox="0 0 36 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className={
                                    open
                                      ? "h-[12px] w-[12px] -ml-6px opacity-100 transition ease-in-out absolute bottom-4 left-1/2"
                                      : "h-[12px] w-[12px] -ml-6px opacity-0 transition ease-in-out absolute bottom-4 left-1/2"
                                  }
                                >
                                  <path
                                    d="M17.8431 0.213959L35.6862 31.4842H0L17.8431 0.213959Z"
                                    fill="#0D3552"
                                  />
                                </svg>
                              </Popover.Button>
                            </div>

                            <Transition
                              as={Fragment}
                              enter="transition ease-out duration-200"
                              enterFrom="opacity-0"
                              enterTo="opacity-100"
                              leave="transition ease-in duration-150"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <Popover.Panel className="absolute top-full inset-x-0 text-gray-500 sm:text-xl font-heading text-ec-sea border-t-4 border-b-2 border-ec-earth">
                                {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}
                                <div
                                  className="absolute inset-0 top-1/2 bg-ec-air shadow"
                                  aria-hidden="true"
                                />

                                <div className="relative bg-ec-air">
                                  <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                                    <div className="grid grid-cols-1 items-start gap-y-10 gap-x-6 pt-2 pb-6 md:grid-cols-1 lg:gap-x-8">
                                      <div className="grid grid-cols-1 gap-y-10 gap-x-6 lg:gap-x-8">
                                        <div className="mt-4 flex justify-between">
                                          {category.types.map((item) => (
                                            <div
                                              key={item.name}
                                              className="flex"
                                            >
                                              <a
                                                href={item.href}
                                                className="hover:text-gray-800"
                                              >
                                                <p className="text-center">
                                                  {item.name}
                                                </p>
                                              </a>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Popover.Panel>
                            </Transition>
                          </>
                        )}
                      </Popover>
                    ))}

                    {navigation.simple.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="flex items-center text-xl font-heading uppercase text-ec-sea font-medium text-gray-700 hover:text-gray-800"
                      >
                        {item.name}
                      </a>
                    ))}
                    <Link
                      to="/articles"
                      className="flex items-center text-xl font-heading uppercase text-ec-sea font-medium text-gray-700 hover:text-gray-800"
                    >
                      Discover
                    </Link>
                    <Link
                      to="/contact"
                      className="flex items-center text-xl font-heading uppercase text-ec-sea font-medium text-gray-700 hover:text-gray-800"
                    >
                      Contact
                    </Link>
                  </div>
                </Popover.Group>

                <div className="flex-1 flex items-center justify-end gap-2">
                  {/* Search */}
                  <Link
                    to="/catalogue"
                    className="hidden lg:flex hover:text-gray-500"
                  >
                    <span className="sr-only">Search</span>
                    <svg
                      className="flex-shrink-0 h-6 w-6 md:h-6 md:w-6 fill-gray-500 hover:fill-ec-sea"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M21 13.242V20h1v2H2v-2h1v-6.758A4.496 4.496 0 0 1 1 9.5c0-.827.224-1.624.633-2.303L4.345 2.5a1 1 0 0 1 .866-.5H18.79a1 1 0 0 1 .866.5l2.702 4.682A4.496 4.496 0 0 1 21 13.242zm-2 .73a4.496 4.496 0 0 1-3.75-1.36A4.496 4.496 0 0 1 12 14.001a4.496 4.496 0 0 1-3.25-1.387A4.496 4.496 0 0 1 5 13.973V20h14v-6.027zM5.789 4L3.356 8.213a2.5 2.5 0 0 0 4.466 2.216c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 0 0 4.644 0c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 1 0 4.457-2.232L18.21 4H5.79z" />
                    </svg>
                    {/* <SearchIcon
                      className="flex-shrink-0 h-6 w-6 md:h-6 md:w-6 text-gray-500 hover:text-ec-sea"
                      aria-hidden="true"
                    /> */}
                  </Link>

                  {/* Cart */}
                  <div className="flow-root  lg:ml-4">
                    <div
                      onClick={() => setOpenCart(true)}
                      className="group flex items-center"
                    >
                      <CartButton
                        quantity={quantity}
                        className="flex-shrink-0 h-8 w-8 lg:h-6 lg:w-6 md:h-8 md:w-8 text-ec-sea group-hover:text-gray-500"
                        aria-hidden="true"
                      />
                      <span className="sr-only">items in cart, view bag</span>
                    </div>

                    <Transition.Root show={openCart} as={Fragment}>
                      <Dialog
                        as="div"
                        className="relative z-[102]"
                        onClose={setOpenCart}
                      >
                        <Transition.Child
                          as={Fragment}
                          enter="ease-in-out duration-500"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in-out duration-500"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        <div className="fixed inset-0 overflow-hidden">
                          <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                              <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-500"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-500"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                              >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                  <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                    <div className="flex-1 overflow-y-auto py-6 px-4 sm:px-6">
                                      <div className="flex items-start justify-between">
                                        <Dialog.Title className="text-2xl font-medium text-ec-sea font-heading">
                                          {" "}
                                          Shopping cart{" "}
                                        </Dialog.Title>
                                        <div className="ml-3 flex h-7 items-center">
                                          <button
                                            type="button"
                                            className="-m-2 p-2 text-gray-400 hover:text-gray-500"
                                            onClick={() => setOpenCart(false)}
                                          >
                                            <span className="sr-only">
                                              Close panel
                                            </span>
                                            <XIcon
                                              className="h-6 w-6"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        </div>
                                      </div>
                                      {emptyCart ? (
                                        <div className="py-12 text-center">
                                          <h1 className="text-2xl font-heading text-ec-earth py-6">
                                            Your cart is empty
                                          </h1>
                                          <p className="text-ec-sea font-body pb-6">
                                            Looks like you haven’t found
                                            anything yet. We understand that
                                            sometimes it’s hard to choose —
                                            maybe this helps:
                                          </p>
                                          <Link
                                            to="/catalogue"
                                            className="mx-auto flex items-center justify-center rounded-full border-2 border-ec-earth bg-ec-earth px-6 py-3 text-lg font-heading text-white hover:bg-transparent hover:text-ec-earth transition ease-in-out w-64"
                                          >
                                            View trending products
                                          </Link>
                                        </div>
                                      ) : (
                                        <>
                                          {" "}
                                          <div className="mt-8">
                                            <div className="flow-root">
                                              <ul
                                                role="list"
                                                className="-my-6 divide-y divide-gray-200"
                                              >
                                                {checkout.lineItems.map(
                                                  (product) => (
                                                    <CartItem
                                                      item={product}
                                                      key={product.id}
                                                    />
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                                      <div className="flex justify-between text-base font-medium text-gray-900">
                                        <p>Subtotal</p>
                                        <p>
                                          {" "}
                                          {checkout.subtotalPrice
                                            ? formatPrice(
                                                checkout.subtotalPrice
                                                  .currencyCode,
                                                checkout.subtotalPrice.amount
                                              )
                                            : 0}
                                        </p>
                                      </div>
                                      <p className="mt-0.5 text-sm text-gray-500">
                                        Shipping and taxes calculated at
                                        checkout.
                                      </p>
                                      <div className="mt-6">
                                        <button
                                          onClick={handleCheckout}
                                          disabled={loading}
                                          className="flex items-center justify-center rounded-full border-2 border-ec-earth bg-ec-earth px-6 py-3 text-lg font-heading text-white hover:bg-transparent hover:text-ec-earth transition ease-in-out"
                                        >
                                          Checkout
                                        </button>
                                      </div>
                                      <div className="mt-6 flex justify-center text-center text-sm text-gray-500">
                                        <div>
                                          or{" "}
                                          <button
                                            type="button"
                                            className="font-medium text-ec-earth hover:text-ec-earth"
                                            onClick={() => setOpenCart(false)}
                                          >
                                            Continue Shopping
                                            <span aria-hidden="true">
                                              {" "}
                                              &rarr;
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Dialog.Panel>
                              </Transition.Child>
                            </div>
                          </div>
                        </div>
                      </Dialog>
                    </Transition.Root>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </header>
        <Toast show={loading || didJustAddToCart}>
          {!didJustAddToCart ? (
            "Updating…"
          ) : (
            <>
              Added to cart{" "}
              <svg
                width="14"
                height="14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.019 10.492l-2.322-3.17A.796.796 0 013.91 6.304L6.628 9.14a1.056 1.056 0 11-1.61 1.351z"
                  fill="#fff"
                />
                <path
                  d="M5.209 10.693a1.11 1.11 0 01-.105-1.6l5.394-5.88a.757.757 0 011.159.973l-4.855 6.332a1.11 1.11 0 01-1.593.175z"
                  fill="#fff"
                />
                <path
                  d="M5.331 7.806c.272.326.471.543.815.163.345-.38-.108.96-.108.96l-1.123-.363.416-.76z"
                  fill="#fff"
                />
              </svg>
            </>
          )}
        </Toast>
      </div>
    </div>
  )
}

export default Navbar
